module.exports = __webpack_public_path__ + "static/media/Rumble_0.61ead3ff.jpg";